import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,Link,useNavigate,useLocation } from 'react-router-dom';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL,NT_STATUS,getSpinner} from './../constants';
import axios from 'axios';
import {stringToHex, validateInput} from "./../components/forms/validator";
import Waiter from './../assets/gif/blueCircle.gif';
let __assetInfo__={
    token:"",
    assetId:"0.00",
    payDate:"",
    paymentAmount:"0.00",
    remark:""
    
};
const JComponent= ({route}) => {
    const navigate=useNavigate();
    const location=useLocation();
    const [form,setForm]=useState(__assetInfo__);
    const [assetsCategoryList,setAssetsCategoryList]=useState([]);
	const [implAgencyList,setImplAgencyList]=useState([]);
  	const [fundingAgencyList,setFundingAgencyList]=useState([]);
  	const [userAgencyList,setUserAgencyList]=useState([]);
    const [rows,setRows]=useState([]);
    const [fetchOnReq,setFecthOnReq]=useState(false);
    const [assetId,setAssetId]=useState("");
    const [selectedImages,setSelectedImages]=useState([]);
	const [selectedQRImage,setSelectedQRImage]=useState("");
    const [isEditOpened,setIsEditOpend]=useState(false);
    const [showImageBox,setShowImageBox]=useState(false);
	const [showQRBox,setShowQRBox]=useState(false);
    const [remarks,setRemarks]=useState([]);
    //---------------- init---------------------------//
    const getAssetType=(_catId)=>{
		for(let i=0;i<assetsCategoryList.length;i++){
			if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
		}
		return(_catId);
	}
	const getImplAgencyById=(_id)=>{
		for(let i=0;i<implAgencyList.length;i++){
			if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
		}
		return(_id);
	}
	const getUserAgencyById=(_id)=>{
		for(let i=0;i<userAgencyList.length;i++){
			if(userAgencyList[i].userAgencyId===_id) return(userAgencyList[i].userAgencyName);
		}
		return(_id);
	}
	const loadAssetCategoryList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_asset_category.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setAssetsCategoryList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadImplAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_impl_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setImplAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadFundingAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_funding_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setFundingAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadUserAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_user_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setUserAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
      const loadAssetInfo=(_assetId)=>{
        let _rows=[];
		setRows([]);
			let _d={
					token:localStorage.getItem("_xoxex"),
					assetId:_assetId,
				};
			let idata=stringToHex(JSON.stringify(_d));	
			setFecthOnReq(true);	
			var config = {
				method: 'post',
				url: API_CORE_SERVER+"/api/document/get-document.php",
				headers: { 
					'Content-Type': 'application/x-www-form-urlencoded',
					//'Content-Type': 'application/json', 
				},
				data:"i="+idata
			  };
			  axios(config).then(response=>{
				if(response.status===200 && response.data){
					let data=response.data;
					if(data.status===1 && data.data && data.data.length>0){
						let records=data.data;
						for(let i=0;i<records.length;i++){
							let assetId=records[i].assetId;
							try{
									let rec=JSON.parse(records[i].data);
									//console.log(rec);
									_rows.push({ 
										assetId:assetId,
										assetType:rec.assetInfo.assetType,
										assetName:rec.assetInfo.assetName,
										implementAgency:rec.assetInfo.implementAgency,
										fundingAgency:rec.assetInfo.fundingAgency,
										userAgency:rec.assetInfo.userAgency,
										assetDescription:rec.assetInfo.assetDescription,
										panchayat:rec.assetInfo.panchayat,
										address:rec.assetInfo.address,
										village:rec.assetInfo.village,
										block:rec.assetInfo.block,
										beneficiary:rec.assetInfo.beneficiary,
										agrCost:rec.assetDetail.agrCost,
										agrDate:rec.assetDetail.agrDate,
										estCost:rec.assetDetail.estCost,
										estWorkStartDate:rec.assetDetail.estWorkStartDate,
										estWorkCompleteByDays:rec.assetDetail.estWorkCompleteByDays,
										workStartDate:rec.assetDetail.workStartDate,
										workFinishDate:rec.assetDetail.workFinishDate,
										workStatus:rec.assetDetail.workStatus,	// Ongoing | Completed | Paused
										workProgress:rec.assetDetail.workProgress, // 5 10 15 20.....100
										lat:rec.assetDetail.lat,
										lng:rec.assetDetail.lng,
										name:rec.contractorInfo.name,
										photos:rec.assetDetail.photos,
										contractor:rec.contractorInfo
									});
								}catch(e){
									console.log("exp:assetId:"+assetId);
								}
						}
					}
				}
				
				setFecthOnReq(false);
			});
			setRows(_rows);
			
		}
      
    //----------------- end init-----------------------//
    useEffect(()=>{
        const assetId=location.state.assetId;
        setForm({...form,assetId:assetId})
        loadAssetInfo(assetId);
        loadAssetCategoryList();
		loadImplAgencyList();
		loadUserAgencyList();
		loadFundingAgencyList();
        
        console.log("Okat::"+new Date())
    },[])
    const __changeEvent=(e)=>{
        const {name,value}=e.target;
        setForm({...form,[name]:value});
        validateInput("#"+name);
            
    }
    const validateInput=(_qs)=>{
            let isValid=true;
            const input=document.querySelector(_qs);
            const name=input.getAttribute("id");
            input.classList.remove("is-invalid");
            const is_required=input.getAttribute("required")!=undefined?true:false;
            let inputErrLabel=document.querySelector("."+name+"-err");
            let errMessage="";
            if(input.value.trim().length==0 && is_required){
                isValid=false;input.classList.add("is-invalid");
                errMessage="can't be empty";
            }
            if(input.value.trim().length!=0){
                const classes=input.classList;
                if((classes.contains("input-text") && !/^[a-zA-Z]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-decimal") && !/^\d+(\.\d+)?$/.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-integer") && !/^[0-9]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-text-space") && !/^[a-zA-Z\s]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-text-number") && !/^[a-zA-Z0-9]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-text-number-space") && !/^[a-zA-Z0-9\s]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-text-number-space-dot") && !/^[a-zA-Z0-9\s\.]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-mixed") && !/^[a-zA-Z0-9\s\.\-_]+$/i.test(input.value))){isValid=false;input.classList.add("is-invalid");}
                else if((classes.contains("input-yyyymmdd") && !/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(input.value))){isValid=false;input.classList.add("is-invalid");}
               errMessage=input.getAttribute("placeholder");
            }
            // create element
            if(isValid==false){
                if(inputErrLabel==undefined){
                    inputErrLabel=document.createElement("div");
                    inputErrLabel.innerHTML=errMessage;
                    inputErrLabel.classList.add("badge");
                    inputErrLabel.classList.add("bg-danger");
                    inputErrLabel.classList.add(name+"-err");
                    
                }
                document.querySelector("#"+name).parentElement.appendChild(inputErrLabel);
                
            }else{
                if(inputErrLabel!=undefined)
                    document.querySelector("."+name+"-err").remove();
            }
            return(isValid);
    }
    const validateForm=(_form_class)=>{
        let formData={};
        let isValid=true;
        const inputs=document.querySelector(_form_class).querySelectorAll(".input");
        for(let i=0;i<inputs.length;i++){
            const input=inputs[i];
            const name=input.getAttribute("id");
            formData[name]=input.value;
            isValid=validateInput("#"+name);
        }
        return({isValid:isValid,formData:formData});
    }
    const sendRecord=(_pageURL,_param,_button)=>{
            _param['token']=localStorage.getItem('_xoxex');
            document.querySelector(_button).innerHTML=getSpinner();
            axios.post(_pageURL,_param)
            .then(response => {
                if(response.status==200){
                    const data=response.data;
                    if(data.status==1){
                        document.querySelector(".form").reset();
                        document.querySelector(".err").innerHTML="SUCCESSFULLY SAVED";
                        setTimeout(()=>{
                        document.querySelector(".err").innerHTML="";
                        },5000);
                    }
                    else if(data.status==-1){
                    document.querySelector(".err").innerHTML=data.msg;
                    document.querySelector("#"+data.data).classList.add("is-invalid");
                    }
                    else document.querySelector(".err").innerHTML=data.msg;
                }
                document.querySelector(_button).innerHTML="SUBMIT";
            })
            .catch(error => {
                document.querySelector(_button).innerHTML="SUBMIT";
                const _code=error.code;
                if(error.response!=undefined){
                    const _status=error.response.status;
                    if(NT_STATUS[_code]!=undefined){
                    document.querySelector(".err").innerHTML=NT_STATUS[_code].message;
                    }
                }
                else{
                    if(NT_STATUS[_code]!=undefined){
                        document.querySelector(".err").innerHTML=NT_STATUS[_code].message;
                    }	
                }
            
            });

        }

    const __submit=(e)=>{
        document.querySelector(".err").innerHTML="";
        const formData=validateForm(".form");
        if(formData.isValid==true){
            if(document.querySelector("#cmd_submit_payment").innerText.trim()=="SUBMIT"){
                const form=validateForm(".form");
                console.log(form);
                sendRecord(API_CORE_SERVER+"/api/payment/payment.do.php",form.formData,"#cmd_submit_payment");
            }
        }
        else console.log("Invalid Form");
        
    }

    return(
        <>
        
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Add New Payment</h5>
		<div className='row'>
		<div className='col-md-8 p-4'>
            <div className='px-4 py-4'>
                <div className="" >
                    {/*--------------*/}
                    {fetchOnReq===true && 
                        <>
                            <img src={Waiter} className='waiter-md'/>
                        </>
                    }
                    {(fetchOnReq===false && rows.length>=1) && 
                        <>
                        { rows && rows.map((item,i)=>{
                                        return(
                                            i===0?
                                            <>
                                            <div className="d-flex">
                                                <div className="flex-grow-1">
                                                    <div className="d-flex align-items-end img-md">
                                                            {
                                                            item && item.photos && item.photos.split(",").map((ph,iph)=>{
                                                            return(iph>0?
                                                                    
                                                                        <img src={API_CORE_SERVER+"/_apithumbnail/"+ph}
                                                                        data={ph}
                                                                        className="cursor-pointer"
                                                                        onClick={e=>{
                                                                            
                                                                            setSelectedImages([e.target.getAttribute("data")]);
                                                                            setShowImageBox(true);
                                                                        }}
                                                                        />
                                                                    
                                                                    :<></>
                                                                )
                                                            })}
                                                            
                                                            
                                                    </div>
                                                </div>		
                                                <div className="cursor-pointer img-md">
                                                        <img 
                                                        src={"https://gramsampati.in/api/document/get-qr-code.php?ai="+item.assetId} 
                                                        onClick={e=>{
                                                                        
                                                            setSelectedQRImage(e.target.getAttribute("src"));
                                                            setShowQRBox(true);
                                                        }}
                                                        />
                                                </div>
                                            </div>
                                            <div className='d-flex mt-4'>&nbsp;</div>
                                            <div className="d-flex">
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Agreement cost</div>
                                                    <div className='formValue'>{(item.agrCost)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Agreement date</div>
                                                    <div className='formValue'>{(item.agrDate)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Estimeted cost</div>
                                                    <div className='formValue'>{(item.estCost)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Estimeted work start date</div>
                                                    <div className='formValue'>{(item.estWorkStartDate)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Estimeted Work Finsh by days</div>
                                                    <div className='formValue'> {(item.estWorkCompleteByDays)}</div>
                                                </div>
                                            </div>	

                                            <div className="d-flex">
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Work start date</div>
                                                    <div className='formValue'>{(item.workStartDate)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Work finsh date</div>
                                                    <div className='formValue'>{(item.workFinishDate)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Work status</div>
                                                    <div className='formValue'> {(item.workStatus)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Work progress</div>
                                                    <div className='formValue'> {(item.workProgress)}%</div>
                                                </div>
                                                
                                            </div>	
                                            <div className="d-flex">
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Implementing Agency</div>
                                                    <div className='formValue'> {getImplAgencyById(item.implementAgency)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Funding Agency</div>
                                                    <div className='formValue'>  {item.fundingAgency}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>User Agency</div>
                                                    <div className='formValue'>  {getUserAgencyById(item.userAgency)}</div>
                                                </div>		
                                            </div>
                                            <div className='formDiv'>
                                                <div className='formLabel'>Asset Name</div>
                                                <div className='formValue'>  {item.assetName}</div>
                                            </div>
                                            <div className='formDiv'>
                                                <div className='formLabel'>Description</div>
                                                <div className='formValue'>  {item.assetDescription}</div>
                                            </div>
                                            <div className='formDiv'>
                                                <div className='formLabel'>Asset Type</div>
                                                <div className='formValue'>  {getAssetType(item.assetType)}</div>
                                            </div>

                                            <div className='formDiv'>
                                                <div className='formLabel'>Address</div>
                                                <div className='formValue'>{item.address}</div>
                                            </div>

                                            <div className="d-flex">
                                                <div className='formDiv'>
                                                    <div className='formLabel'>village</div>
                                                    <div className='formValue'>{item.village}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Panchayat</div>
                                                    <div className='formValue'>{item.panchayat}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>block</div>
                                                    <div className='formValue'>{item.block}</div>
                                                </div>
                                            </div>

                                            <div className='formDiv'>
                                                <div className='formLabel'>Beneficiary</div>
                                                <div className='formValue'>{item.beneficiary}</div>
                                            </div>

                                            <div className="d-flex">
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Latitude</div>
                                                    <div className='formValue'> {(item.lat)}</div>
                                                </div>
                                                <div className='formDiv'>
                                                    <div className='formLabel'>Longitude</div>
                                                    <div className='formValue'> {(item.lng)}</div>
                                                </div>
                                            </div>

                                            <div className="card bg-light">
                                                <div className="card-body">
                                                    <h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Contractor Details</h5>
                                                    <div className="d-flex">
                                                        <div className='formDiv'>
                                                            <div className='formLabel'>Contractor Name</div>
                                                            <div className='formValue'>{(item.contractor.name)}</div>
                                                                
                                                        </div>	
                                                        <div className='formDiv'>
                                                            <div className='formLabel'>Contractor Registration No</div>
                                                            <div className='formValue'>{(item.contractor.regNo)}</div>
                                                        </div>
                                                        <div className='formDiv'>
                                                            <div className='formLabel'>Contact No</div>
                                                            <div className='formValue'>{(item.contractor.contactNo)}</div>
                                                        </div>
                                                    </div>	
                                                    <div className='formDiv'>
                                                            <div className='formLabel'>Address</div>
                                                            <div className='formValue'>{(item.contractor.address)}</div>
                                                    </div>		
                                                    <div className="d-flex">
                                                        <div className='formDiv'>
                                                            <div className='formLabel'>District</div>
                                                            <div className='formValue'>{(item.contractor.district)}</div>
                                                        </div>
                                                        <div className='formDiv'>
                                                            <div className='formLabel'>State</div>
                                                            <div className='formValue'>{(item.contractor.state)}</div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            {remarks && remarks.length>=1 &&
                                            <div className="d-flex mt-4">
                                                <div className='w-100'>
                                                
                                                    <div className="cardx">
                                                        <div className="fs-5">Remarks</div>
                                                        <div className="mb-3">
                                                            {remarks && remarks.map((item,index)=>{
                                                                    return(
                                                                        <>
                                                                            <div className='fs85rem text-gray-dark mb-2'>{item.idate}, {item.email}</div>
                                                                            <div className='fs85rem text-gray-hard mb-4'>
                                                                                {
                                                                                    decodeURIComponent(item.data)
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    )
                                                            })}
                                                        </div>
                                                    </div>
                                                
                                                </div>
                                            </div>
                                            }
                                            </>
                                            :<></>	
                                        )
                            })
                            }
                        </>	
                    }
                    {/*--------------*/}
                </div>
            </div>
        </div>    
        <div className='col-md-4 p-4'>
        	<div className='px-4 py-4'>
                <div className="" >
                    <h5 className="mb-4">Payment Entry</h5>
                    <form className="form">
                        <div className="row mb-2">
                            <div className="col-md-12">
                                <div className="form-floating">
                                    <input type="text" className="form-control input input-mixed" id="assetId" name="assetId" placeholder="must be numeric" defaultValue={form.assetId} value={form.assetId} required  />
                                    <label for="psNo">Asset Id</label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-md-12">
                                <div className="form-floating">
                                    <input type="date" className="form-control input input-yyyymmdd" id="payDate" name="payDate" placeholder="must be yyyy-mm-dd"  required onChange={e=>{__changeEvent(e) }} onBlur={e=>{__changeEvent(e) }}/>
                                    <label for="psNo">Payment Date</label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-md-12">
                                <div className="form-floating">
                                    <input type="number" className="form-control input input-decimal" style={{fontWeight:650}} id="paymentAmount"  name="paymentAmount" placeholder="must be numeric" required onChange={e=>{__changeEvent(e) }} onBlur={e=>{__changeEvent(e) }}/>
                                    <label for="psNo">Payment Amount</label>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-12">
                                <div className="form-floating">
                                    <input type="text" className="form-control input input-mixed" id="remark"  name="remark" placeholder="no special character" required onChange={e=>{__changeEvent(e) }} onBlur={e=>{__changeEvent(e) }}/>
                                    <label for="psNo">Remark</label>
                                </div>
                            </div>
                        </div>
                        <div className="mt-2 text-center fs85rem err "></div>
                        <div className="mt-2">
                            <button type="button" className="btn btn-lg btn-primary w-100" id="cmd_submit_payment" onClick={e=>__submit(e)}>
                                SUBMIT
                            </button>
                            <div className="err fs085 text-center text-danger mt-4"></div>
                        </div>    
                    </form>
                </div>



            </div>
        </div>
        </div>    
        {showImageBox===true &&
            <>
            <div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
                <div className="d-flex justify-content-end p-4">
                    <div className="cursor-pointer text-dark" onClick={()=>{
                        setShowImageBox(false);
                    }}>Close</div>
                </div>
                <div className='d-flex vh-100 align-items-center'>
                    <div className='row vw-100' style={{marginTop:'-8rem'}}>
                    <div className='col-md-5 mx-auto border rounded-2 p-4'>
                        <div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Photo </div>
                        <div className='text-center text-black fs-6'  >
                        <img src={API_CORE_SERVER+"/_apistorage/"+selectedImages[0]} style={{maxWidth:'450px',maxHeight:'450px'}}  />
                        </div>
                        <div className='pt-4 text-end' >
                            <button className='btn btn-secondary' onClick={()=>{
                            setShowImageBox(false);
                            }}>Close</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            </>
            }
        </>
    )
}
export default JComponent;
